import { useCallback, useEffect, useState } from 'react'

import Storage from 'app/services/Storage'
import { STORAGE_KEYS } from 'app/utils/constants/storage.constants'

const maxLength = 10

const useRecentlyViewed = ({ slug }: { slug?: string }) => {
  const [items, setItems] = useState<string[]>([])

  const viewedItems = items ? items.filter((item) => item !== slug) : []

  const getItems = async () => {
    const values = await Storage.getItem(STORAGE_KEYS.youRecentlyViewed)

    if (values && values.length) setItems(values)
    return values
  }

  useEffect(() => {
    getItems()
  }, [])

  const setItem = useCallback(async (newItem: string) => {
    let values = await getItems()

    if (!newItem) {
      return
    } else if (!values) {
      values = []
      values.unshift(newItem)
    } else if (values.includes(newItem)) {
      values = values.filter((slug) => slug !== newItem)
      values.unshift(newItem)
    } else if (values.length === maxLength) {
      values.pop()
      values.unshift(newItem)
    } else {
      values.unshift(newItem)
    }

    Storage.setItem(STORAGE_KEYS.youRecentlyViewed, values)
    setItems(values)
  }, [])

  return {
    viewedItems,
    setViewedItem: setItem
  }
}

export default useRecentlyViewed
